// extracted by mini-css-extract-plugin
module.exports = {"enabled":"draft-mode_enabled__dtVsF","loader":"draft-mode_loader__YETvz","spin":"draft-mode_spin__ruhB6"};